import { ApiService } from "./api.service";
import { PrimeIcons } from "@primevue/core/api";
import { DOMAIN } from "./domain-constant";
export default class ClassificationsService extends ApiService {
  namespace = "classification";
  DOMAIN = DOMAIN.CLASSIFICATION;
  name = "Classification";
  template = "defaultTemplate";
  Width = 700;
  action = "action";
  favicon = "BlackBox";
  icon = "BlackBox";
  gemItems = [
    {
      key: "create",
      label: this.t("addAEntity", { entity: "Classification" }),
      icon: PrimeIcons.PLUS_CIRCLE,
    },
  ];

  constructor() {
    super("classifications");
  }
}
